import React, { ForwardedRef } from 'react';
import { useTranslation } from 'react-i18next';
import InvalidFeedback from './invalid-feedback.component';

interface AdvanceRadioProps {
  options: {
    value: string;
    title: string;
    description: string;
    badge?: string;
  }[];
  errors?: any;
  value: string;
  label: string;
  required?: boolean;
  optional?: boolean;
  onChange: (value: string) => void;
}

const AdvanceRadio = React.forwardRef<HTMLInputElement, AdvanceRadioProps>(
  (
    {
      label,
      options,
      errors,
      value,
      required = false,
      optional = false,
      onChange
    }: AdvanceRadioProps,
    ref: ForwardedRef<HTMLInputElement>
  ) => {
    const { t } = useTranslation();
    return (
      <div className="mb-7">
        <label className={`${required ? 'required' : ''} mb-4 form-label`}>{label}</label>
        {optional && <span className="fs-8 text-muted ms-1">({t('general.optional')})</span>}
        {options.map((option, index) => (
          <label
            key={option.value}
            className={`btn btn-outline btn-outline-dashed btn-active-light-primary d-flex flex-stack text-start animate-fadeInUp animate-delay-${index} p-6 mb-5 ${value === option.value ? 'active' : ''}`}
          >
            <div className={`d-flex align-items-center me-2`}>
              <div className="form-check form-check-custom form-check-solid form-check-primary me-6">
                <input
                  className="form-check-input"
                  type="radio"
                  value={option.value}
                  checked={value === option.value}
                  onChange={(e) => onChange(e.target.value)}
                  ref={ref}
                />
              </div>
              <div className="flex-grow-1">
                <h2 className="d-flex align-items-center fs-3 fw-bold flex-wrap">
                  {option.title}
                  {option.badge && (
                    <span className="badge badge-light-primary ms-2 fs-7">{option.badge}</span>
                  )}
                </h2>
                <div className="fw-semibold opacity-50">{option.description}</div>
              </div>
            </div>
          </label>
        ))}
        <span className="text-danger mb-3">{errors && errors.message} </span>
        <InvalidFeedback error={errors} />
      </div>
    );
  }
);

export default AdvanceRadio;
